module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Selected-file-a3c0de548f636c91439d6a4e27f33597.svg";